import { Col, Row } from '@qonsoll/react-design'
import {
  HeaderBreadcrumbs,
  PageActions,
  PageWrapperActionsUnderTitle,
  Spinner
} from 'components'
import { RewardFilter, RewardTable } from 'domains/Reward/components'
import { useFilter, useGetCustomDataSource } from 'hooks'
import { useGetRewards, useRewardBaseActions } from 'domains/Reward/hooks'
import { useMemo, useState } from 'react'

import { COLLECTIONS } from '__constants__'
import PATHS from 'pages/paths'
import PropTypes from 'prop-types'
import { useTranslations } from 'contexts/Translation'

const RewardsAllPage = (props) => {
  const { withHeader = true } = props

  const [collection, setCollection] = useState()

  /* Getting translations instance */
  const { t } = useTranslations()

  /* Getting filter params */
  const filterParams = useFilter('reward')

  /* Destructuring filter params */
  const { filterVisibility, filterData, setFilterVisibility } = filterParams

  /* Building filter query */
  const ref = useMemo(() => filterData, [filterData])

  /* Fetching rewards */
  const [rewards, loading] = useGetRewards(ref)
  const [customDataSource, customDataSourceLoading] = useGetCustomDataSource(
    rewards,
    { status: COLLECTIONS.REWARD_STATUSES }
  )

  /* Getting base actions */
  const listActions = useRewardBaseActions()

  /* Configuring page header */
  const headingProps = {
    title: t('Rewards'),
    titleSize: 3,
    marginBottom: 3,
    textAlign: 'left'
  }

  /* Configuring page actions */
  const actions = {
    filter: true,
    create: Boolean(
      PATHS.AUTHENTICATED.REWARD_CREATE || PATHS.AUTHENTICATED.REWARD_WIZARD
    ),
    search: true
  }

  /* Extracting base actions */
  const { onBack, onCreate } = listActions

  return (
    <PageWrapperActionsUnderTitle
      action={
        withHeader ? (
          <PageActions
            {...filterParams}
            onCreate={onCreate}
            actions={actions}
            circle
            filterMenu={<RewardFilter {...filterParams} />}
            filterVisibility={filterVisibility}
            setFilterVisibility={setFilterVisibility}
            collection={customDataSource}
            setCollection={setCollection}
            searchPlaceholder="Search by Reward Name"
            searchField="name"
          />
        ) : null
      }
      onBack={withHeader ? onBack : null}
      breadcrumbs={withHeader ? <HeaderBreadcrumbs /> : null}
      headingProps={withHeader ? headingProps : null}>
      <Row noGutters>
        {loading || customDataSourceLoading ? (
          <Col>
            <Spinner height="60vh" text={t('Reward loading')} />
          </Col>
        ) : (
          <Col cw={12}>
            <RewardTable dataSource={collection ?? customDataSource} />
          </Col>
        )}
      </Row>
    </PageWrapperActionsUnderTitle>
  )
}

RewardsAllPage.propTypes = {
  isListWithCreate: PropTypes.bool,
  withHeader: PropTypes.bool
}

export default RewardsAllPage
